<template>
	<transition name="fade">
	  <div class="xw-pop-modalbox" v-if="isPopShow">
	  	<div class="xw-pop-modal-section">
	  		<div class="xw-pop-modal-header"><div v-html="title"></div><span class="xw-pop-modal-close" title="关闭" @click="close"></span></div>
	  		<slot name="xw-pop-modal-body"></slot>
	  		<div class="xw-pop-modal-btn" v-if="isShowButton">
	  			<a class="xw-pop-modal-btn-no" @click="quit" v-if="isShowCancel">{{$i18n.locale=='zh'?cancelBtn_zh:cancelBtn_hk}}</a>
	  			<a class="xw-pop-modal-btn-yes" @click="sure">{{$i18n.locale=='zh'?sureBtn_zh:sureBtn_hk}}</a>
	  		</div>
	  	</div>
	  </div>
  	</transition>
</template>
 
<script>
export default {
  name: 'xwpop',
  props: {
  	"isPopShow": {
  		type: Boolean,
  		default: false
  	},
  	"cancelBtn_zh": {
  		type: String,
  		default: '取消'
  	},
  	"cancelBtn_hk": {
  		type: String,
  		default: '取消'
  	},
  	"sureBtn_zh": {
  		type: String,
  		default: '确定'
  	},
  	"sureBtn_hk": {
  		type: String,
  		default: '確定'
  	},
  	"isShowCancel": {
  		type: Boolean,
  		default: true
  	},
		"title": [String, Number],
		"isShowButton": {
			type: Boolean,
			default: true
		}
  },
  methods: {
  	quit () {
  		this.$emit("on-cancel");
  	},
  	sure () {
  		this.$emit("on-sure");
  	},
  	close () {
			this.$emit("update:isPopShow",false);
  		//判断body html 是否被固定高度
  		if(document.documentElement.classList.contains("bodyfix")||document.body.classList.contains("bodyfix")){
  			//去掉body html class类名
			document.documentElement.classList.remove("bodyfix")
			document.body.classList.remove("bodyfix")
  		}
  	},
//	fadeOut (e) {
//		if(e.target.classList.contains('xw-pop-modalbox')){
//			this.$emit("update:isPopShow",false);
//		}
//	}
  },
  
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pop.vue